import React from 'react';
import PropTypes from 'prop-types';
import Adjust from 'wix-ui-icons-common/Adjust';
import MagnifyingGlass from 'wix-ui-icons-common/Search';
import MenuLabel from '../FilterLabel/index.js';
import { translate } from 'react-i18next';
import styles from './SearchInput.scss';
import X from 'wix-ui-icons-common/X';
import BILogger from '../../utils/BILogger';
import { Input, IconButton, Tooltip } from 'wix-style-react';

const LABELS = ['organic', 'vegetarian', 'gluten-free', 'vegan', 'spicy1', 'spicy2', 'spicy3'];

class SearchInput extends React.Component {
  static propTypes = {
    query: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onFilter: PropTypes.func,
    onClearFilters: PropTypes.func,
    t: PropTypes.func,
    organizationId: PropTypes.string,
    searchTooltipContent: PropTypes.string,
    filterTooltipContent: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
    onFilter: () => {},
    onClearFilters: () => {},
  };

  constructor() {
    super();

    this._showFilters = this._showFilters.bind(this);
    this._getMenuLabel = this._getMenuLabel.bind(this);
    this._onFilter = this._onFilter.bind(this);
    this._clear = this._clear.bind(this);
  }

  render() {
    const { className } = this.props;
    const controller = this._getController();
    const filters = this._getFilters();

    return (
      <div className={`${styles.wrapper} ${className}`} data-hook="search-input-wrapper">
        {controller}
        {filters}
      </div>
    );
  }

  _getController() {
    const { onChange, query, t, showFilters, searchRef, searchTooltipContent, filterTooltipContent } = this.props;

    const suffix = query ? (
      <IconButton skin="inverted" onClick={this._clear}>
        <X />
      </IconButton>
    ) : null;

    const searchBar = (
      <div className={styles.search} data-hook="search-input">
        <Input
          ref={searchRef}
          className={styles.input}
          value={query}
          placeholder={t('phoneordering_menu_searchbar_placeholder')}
          onChange={onChange}
          suffix={suffix}
        />
        <MagnifyingGlass size={24} className={styles.icon} />
      </div>
    );
    const filters = (
      <div
        className={`${styles.filterToggle} ${showFilters ? styles.activated : ''}`}
        onClick={this._showFilters}
        data-hook="search-input-filter"
      >
        <Adjust size={22} />
      </div>
    );
    return (
      <div className={styles.controller}>
        {searchTooltipContent ? (
          <Tooltip
            size={'small'}
            enterDelay={500}
            className={styles.search}
            content={searchTooltipContent}
            appendTo={'window'}>
            {searchBar}
          </Tooltip>
        ) : (
          searchBar
        )}
        {filterTooltipContent ? (
          <Tooltip enterDelay={500} size={'small'} content={filterTooltipContent}>
            {filters}
          </Tooltip>
        ) : (
          filters
        )}
      </div>
    );
  }

  _getFilters() {
    const { showFilters } = this.props;

    return showFilters ? (
      <div data-hook="filters-labels-wrapper" className={styles.filters}>
        {LABELS.map(this._getMenuLabel)}
      </div>
    ) : null;
  }

  _getMenuLabel(label) {
    const { filters, t } = this.props;
    const labelKey = this._labelKey(label);

    const tmpLabels = {
      hot: t('phoneordering_menu_filter_hot'),
      spicy2: t('phoneordering_menu_filter_hot'),
      extrahot: t('phoneordering_menu_filter_extrahot'),
      spicy3: t('phoneordering_menu_filter_extrahot'),
      glutenfree: t('phoneordering_menu_filter_glutenfree'),
      organic: t('phoneordering_menu_filter_organic'),
      spicy: t('phoneordering_menu_filter_spicy'),
      spicy1: t('phoneordering_menu_filter_spicy'),
      vegan: t('phoneordering_menu_filter_vegan'),
      vegetarian: t('phoneordering_menu_filter_vegetarian'),
    };

    return (
      <MenuLabel
        key={label}
        label={label}
        name={tmpLabels[labelKey]}
        active={filters[label]}
        onClick={this._onFilter}
      />
    );
  }

  _onFilter(label) {
    const { onFilter } = this.props;
    onFilter(label);
  }

  _showFilters() {
    const { onClearFilters, organizationId, showFilters, toggleFilters } = this.props;
    const nextShowFilters = !showFilters;
    toggleFilters();
    if (!nextShowFilters) {
      onClearFilters();
    }

    BILogger.menuFilter({ isOpen: nextShowFilters, organizationId });
  }

  _labelKey(label) {
    return label.replace(/-/g, '');
  }

  _clear() {
    this.props.onChange({ target: { value: '' } });
  }
}

export default translate()(SearchInput);
